module.exports = __webpack_public_path__ + "static/media/arrow-down.e67bbff7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/arrow-down.svg
// module id = 47
// module chunks = 0